module.exports = __webpack_public_path__ + "img/Icon_LockClosed_Gray.f8499f87.svg";